module.exports = __webpack_public_path__ + "img/208.669b51d8.png";